import {DG_axios} from "../../../custom/axios";
import {DG_axiosNormal} from "../../../custom/axios/normal";
import {message} from "antd";
import {Translation} from "react-i18next";

const url = "/dogoo/files-manager-rest/v2.0/files"

const externalUrl = process.env.REACT_APP_DOC_FILE_API

export async function getFilePermissions(id) {
    const response = await DG_axios.get(url + "/" + id + "/file-permissions", null)
    return response.data || [];
}

export async function updateSettingPermission(fileId, settingPermission) {
    await DG_axiosNormal.put(url + "/" + fileId + "/permissions/setting", settingPermission).then(() => {
        message.success(<Translation>
            {(t, {i18n}) =>
                <span>{t("common.message.update")}</span>}
        </Translation>)
    })
}

export async function updateGeneralPermission(fileId, generalPermission) {
    await DG_axiosNormal.put(url + "/" + fileId + "/permissions/general", generalPermission).then(() => {
        message.success(<Translation>
            {(t, {i18n}) =>
                <span>{t("common.message.update")}</span>}
        </Translation>)
    })
}


export async function updatePermissionAccepted(fileId, type, acceptedId, role) {
    await DG_axiosNormal.put(url + "/" + fileId + "/permissions/" + type + "/" + acceptedId, {
        "role": role
    }).then(() => {
        message.success(<Translation>
            {(t, {i18n}) =>
                <span>{t("common.message.update")}</span>}
        </Translation>)
    })
}

export async function deletePermissionAccepted(fileId, type, acceptedId) {
    await DG_axios.delete(url + "/" + fileId + "/permissions/" + type + "/" + acceptedId)
}


export async function updateFilePermission(fileId, permission) {
    const response = await DG_axios.post(url + "/" + fileId + "/file-permissions", permission)
    return response.data || [];
}

export async function createGuest(guest) {
    const response = await DG_axiosNormal.post(externalUrl + "/external/guests", guest)
    return response.data || [];
}

export async function getAllGuests(fileId) {
    const response = await DG_axios.get(externalUrl + "/external/guests/" + fileId)
    return response.data || [];
}

export async function deleteGuest(guestId) {
    const response = await DG_axiosNormal.delete(externalUrl + "/external/guests/" + guestId).then(() => {
        message.success(<Translation>
            {(t, {i18n}) =>
                <span>{t("common.message.delete")}</span>}
        </Translation>)
    })
}

export async function checkGuest(params) {
    const response = await DG_axiosNormal.post(externalUrl + "/external/guests/files/check", params)
    return response.data || [];
}

export async function getUrlDownloadFile(fileId) {
    const response = await DG_axiosNormal.get(url + "/" + fileId + "/download")
    return response.data || []
}

export async function checkEditFile(fileId) {
    const response = await DG_axiosNormal.get(externalUrl + "/editor/check/" + fileId)
    return response.data || []
}
